"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'ai.com.choose_model': 'Choose model',
    'ai.com.choose_provider': 'Choose provider',
    'ai.com.choose_avatar': 'Choose avatar',
};
